import { POST } from '@sisyphe/utils'

/**
 * @description 用户地址新增
 */
export function addressAddUsingPOST(
  params: SwaggerDTO.地址新增请求参数
): Promise<SwaggerDTO.ResponseResult<SwaggerDTO.XXFResponseResult>> {
  return POST(
    '/enterprise-procurement-client/enterprise/store/address/add',
    params
  )
}

/**
 * @description 设为默认地址
 */
export function addressDefaultUsingPOST(
  id
): Promise<SwaggerDTO.ResponseResult<SwaggerDTO.XXFResponseResult>> {
  return POST(
    `/enterprise-procurement-client/enterprise/store/address/default/${id}`
  )
}

/**
 * @description 用户地址删除
 */
export function addressDelUsingPOST(
  id
): Promise<SwaggerDTO.ResponseResult<SwaggerDTO.XXFResponseResult>> {
  return POST(
    `/enterprise-procurement-client/enterprise/store/address/del/${id}`
  )
}

/**
 * @description 用户地址编辑
 */
export function addressEditUsingPOST(
  params: SwaggerDTO.地址新增请求参数
): Promise<SwaggerDTO.ResponseResult<SwaggerDTO.XXFResponseResult>> {
  return POST(
    '/enterprise-procurement-client/enterprise/store/address/edit',
    params
  )
}

/**
 * @description 订单-确认收货
 */
export function ensureOrderUsingPOST(
  params?: any
): Promise<SwaggerDTO.ResponseResult<SwaggerDTO.BaseResponseDTO>> {
  return POST(
    '/enterprise-procurement-client/enterprise/store/ensure/order',
    params
  )
}

/**
 * @description 订单列表查询
 */
export function queryOrderListUsingPOST(
  params?: any
): Promise<SwaggerDTO.ResponseResult<SwaggerDTO.BaseResponseDTO>> {
  return POST(
    '/enterprise-procurement-client/enterprise/store/order/query',
    params
  )
}

/**
 * @description 订单详情查询
 */
export function queryOrderDetailUsingPOST(
  params?: any
): Promise<SwaggerDTO.ResponseResult<SwaggerDTO.BaseResponseDTO>> {
  return POST(
    '/enterprise-procurement-client/enterprise/store/order/queryDetail',
    params
  )
}

/**
 * @description 订单-再来一单
 */
export function orderRepeatUsingPOST(
  params?: any
): Promise<SwaggerDTO.ResponseResult<SwaggerDTO.BaseResponseDTO>> {
  return POST(
    '/enterprise-procurement-client/enterprise/store/order/repeat',
    params
  )
}

/**
 * @description 个人帐号信息-收获地址管理
 */
export function queryUserAddressUsingPOST(
  params?: any
): Promise<{ data: Array<SwaggerDTO.地址信息> }> {
  return POST(
    '/enterprise-procurement-client/enterprise/store/user/address',
    params
  )
}

/**
 * @description 个人帐号信息-企业档案
 */
export function queryUserEnterpriseUsingPOST(
  params?: any
): Promise<SwaggerDTO.ResponseResult<SwaggerDTO.企业信息帐号信息>> {
  return POST(
    '/enterprise-procurement-client/enterprise/store/user/enterprise',
    params
  )
}

/**
 * @description 个人帐号信息-个人信息
 */
export function queryUserInfoUsingPOST(
  params?: any
): Promise<SwaggerDTO.ResponseResult<SwaggerDTO.账户信息>> {
  return POST(
    '/enterprise-procurement-client/enterprise/store/user/info',
    params
  )
}

/**
 * @description 个人帐号信息-成员信息
 */
export function queryUserRelationUsingPOST(
  params: SwaggerDTO.帐号信息查询参数
): Promise<SwaggerDTO.ResponseResult<SwaggerDTO.帐号信息成员信息Req>> {
  return POST(
    '/enterprise-procurement-client/enterprise/store/user/other',
    params
  )
}

/**
 * @description 个人帐号信息-可用额度
 */
export function queryUserQuotaUsingPOST(
  params: SwaggerDTO.帐号信息查询参数
): Promise<SwaggerDTO.ResponseResult<SwaggerDTO.帐号信息可用额度Req>> {
  return POST(
    '/enterprise-procurement-client/enterprise/store/user/quotas',
    params
  )
}
